import { useTranslation } from 'react-i18next'

import { useNotification, useUkTimeZone } from '../../../../hooks'
import {
  downloadRentalPortalCsv,
  getRentalPortalExportColumns,
  getRentalPortalExportFileName,
  getRentalPortalExportItems,
  getRentalPortalExportRows,
} from '../../RentalPortal.utils'

export function useRentalPortalExport({
  checkIsItemSelected,
  columns,
  getValue,
  items,
  section,
  selectAllPages,
  selected,
}) {
  const { t } = useTranslation()

  const { locale, timezone } = useUkTimeZone()

  const { handleAddSuccessNotification } = useNotification()

  const exportItems = getRentalPortalExportItems({
    checkIsItemSelected,
    items,
    selectAllPages,
    selected,
  })

  function handleExport() {
    const rows = getRentalPortalExportRows({
      columns: getRentalPortalExportColumns(columns),
      getValue,
      items: exportItems,
      locale,
      t,
      timezone,
    })

    downloadRentalPortalCsv({
      fileName: getRentalPortalExportFileName(section),
      rows,
    })

    handleAddSuccessNotification({
      title: t('RentalPortal.ExportDoneNotificationKey', {
        count: exportItems.length,
      }),
    })
  }

  return { handleExport, isExportAvailable: exportItems.length > 0 }
}
